/* Core & libraries */
import React from "react";
import { FormattedMessage, useIntl } from 'react-intl';

/* Helpers, constants, custom methods, internal libraries */
import { useGenericApiFetch } from "../endpoints/base";
import {
  RETRO_ATM_TEMPLATE_DOWNLOAD_ENDPOINT,
  RETRO_DOWNLOAD_ENDPOINT,
  RETRO_GRID_ENDPOINT,
} from '../endpoints/endpoints';
import { useUserContext } from "../contexts/userContext";
import { useNotificationContext } from "../contexts/notificationContext";
import { filtersMap } from '../helpers/filtersMap';
import csvDownload from 'json-to-csv-export';

/* Components */
/* Styles */

export const useRetroService = () => {
  const { setNotification } = useNotificationContext();
  const { genericApiFetch } = useGenericApiFetch();
  const userDetails = useUserContext();
  const companyEntityId = userDetails?.userInfo?.companyInfo?.companyEntityId
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;
  const intl = useIntl();

  const downloadSample = async () => {
    const response = await  genericApiFetch({
      url: RETRO_ATM_TEMPLATE_DOWNLOAD_ENDPOINT.replace("{providerCode}", providerCode?.toLowerCase()).replace("{companyEntityId}", companyEntityId),
      method: "GET",
      spinner: "retroAtmDownloadSpinner",
      responseType: 'blob',
    })
    if (response.success) {
      return  response.data;
    } else {
      setNotification(
        "error",
        <FormattedMessage id="loyalty.atmBulkImport.reportErrorTitle" />,
        <FormattedMessage id="loyalty.atmBulkImport.reportErrorText" />
      )
      return false
    }
  };
  const getCreditRequestHistoryList = async (gridOptions) => {
    gridOptions = filtersMap(gridOptions);
    const response = await genericApiFetch({
      url: RETRO_GRID_ENDPOINT.replace("{companyEntityId}", companyEntityId).replace("{status}", gridOptions?.status),
      method: "GET",
      queryParams: gridOptions,
      spinner: "creditRequestGridSpinner"
    });
    if (response.success) {
      return response.data;
    } else {
      return { results: null };
    }
  };

  const downloadReport = async (gridOptions) => {
    const response = await genericApiFetch({
      url: RETRO_DOWNLOAD_ENDPOINT.replace("{companyEntityId}", companyEntityId).replace("{status}", gridOptions?.status),
      method: "GET",
      spinner: "creditRequestDownloadSpinner"
    });

    if (response.success) {
      const headers = response?.data?.columns?.map((key) => ({
        key,
        label: intl.formatMessage({ id:`retro.${key}`})
      }));
      if (headers?.length > 0) {
        const modifiedItems = response?.data?.items?.map(item => ({
          ...item,
          ...(item?.description && {
            description: intl.formatMessage({ id: item?.description })
          })
        }));

        csvDownload({
          headers,
          data: modifiedItems,
          filename: response?.data?.fileName,
          delimiter: ",",
          fileType: "text/csv"
        });
        return true
      }
    }
    setNotification(
      "error",
      <FormattedMessage id="notifications.reportErrorTitle" />,
      <FormattedMessage id="notifications.reportErrorText" />
    )
    return false
  };

  return {
    downloadSample,
    getCreditRequestHistoryList,
    downloadReport,
  };
}
